import { render, staticRenderFns } from "./EventListInPanel.vue?vue&type=template&id=f483e0be&scoped=true&"
import script from "@/scripts/Events/components/EventListInPanel?vue&type=script&lang=js&"
export * from "@/scripts/Events/components/EventListInPanel?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f483e0be",
  null
  
)

export default component.exports